import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Spring } from 'react-spring';
import { history } from '../../helpers/history';
import SaayaLogo from '../../static/images/saaya-logo-new.png';
import AlfalahLogo from '../../static/images/alfalahlogo.png';
import PakQatarLogo from '../../static/images/pakqatarlogo.png';
import Footer from "../../components/Footer/footer";
import { constants } from '../../Constants';
import { resetLink } from '../../helpers/ConstantID';

class PasswordChanged extends Component {
	constructor(props) {
	  super(props);
	  this.state = {
		is_mobile: false
	  }
	}

	componentDidMount() {
		window.innerWidth <= 700 ? this.setState({is_mobile: true}) : this.setState({is_mobile: false})
	}

	redirectToSignIn() {
		history.replace('/');
	}

	render() {
		const {whitelabel} = this.props;
		return (
			<div className="sh-layout">
				<div className="sh-account-verify-comp">
					<div className="sh-gnrl-inner">
						<div className="sh-gnrl-logo">
							
							<img src={whitelabel ? whitelabel[0].logo_url : SaayaLogo} alt="logo" id={resetLink.sh_rl_logo} />
						</div>
						<div className="sh-avc-heading">
							<h2 className="sh-avc-h2" id={resetLink.sh_rl_text1}>
								{constants.ALL_SET_TXT}
							</h2>
							<p className="sh-avc-gnrl-text sh-mb-15" id={resetLink.sh_rl_text2}>
								{constants.PASSWORD_CHANGED_TXT}
							</p>
						</div>
						<div className="sh-avc-form">

							<div className="sh-gnrl-row sh-mb-10">
								<button id={resetLink.sh_rl_btn} className="sh-gnrl-btn sh-login-btn" onClick={this.redirectToSignIn}>
									{constants.SIGN_IN}
								</button>
							</div>
							
							<div className="sh-gnrl-row">
								<label htmlFor={resetLink.sh_rl_cs_btn} className="sh-avc-cnslr">
						{constants.NEED_HELP_TXT} <span>{constants.CUSTOMER_SUPPORT_TXT}</span>
								</label>
								<button
									className="sh-avc-cnslr-btn"
									onClick={() => {
									console.log("this is button click");
									}}
									id={resetLink.sh_rl_cs_btn}
								></button>
							</div>
						</div>
					</div>
				</div>
				<Footer/>
			</div>			
		);
	}
}


function mapStateToProps(state) {
	const { alert } = state;
	const { registering } = state.reg;
	const { whitelabel } = state.whitelabel;
	return {
		alert,
		registering,
		whitelabel,
	};
}


export default withRouter(connect(mapStateToProps)(PasswordChanged));




// WEBPACK FOOTER //
// ./src/components/PasswordChanged/index.js